module.exports = __webpack_public_path__ + "img/004-xlsx.b673a243.svg";